var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0CAD7E",
    fillRule: "evenodd",
    d: "M.75 13.138c1-.938 5-.938 7-1.876 2-.939 3.114-1.557 6-3.754 2.211-1.684 3-7.508 6-7.508 2.72 0 2.72 3.754 0 11.262h7c1 0 3 2.815 1 5.58.812 1.163 1 2.866-.16 5.32.548 1.058.16 3.176-.95 4.409.073 1.68-.557 2.834-1.89 3.46-4.667.625-8.333.625-11 0-4-.939-12-1.939-13-2.877-1-.939-1-13.077 0-14.016z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.ee08899a14871bd63f135bbed4fe8f17.svg";
export { ForwardRef as ReactComponent };